import { Button, Container, Nav, Navbar, NavDropdown, Image} from 'react-bootstrap'
import { Link } from 'react-router-dom'

function Header() {
  return (
    <CollapsibleExample/>
  )
}

function CollapsibleExample() {
  return (
    <Container>
      <Navbar collapseOnSelect expand="lg" data-bs-theme="dark" className='main-nav'>
        <Navbar.Brand as={Link} to="/">
          <Image fluid
            src='/images/chat-icon.svg' 
            style={{width:'30px', height:'30px', marginRight:'4px'}}/>
            QuickyChat
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="me-auto">
            <NavDropdown title="Platform" id="collapsible-nav-dropdown">
                <NavDropdown.Item as={Link} to="/quickstart">Quick start</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/whatsapp">WhatsApp</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/api-access">API Access</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/demo">Demo</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link as={Link} to="/solutions">Solutions</Nav.Link>
            <Nav.Link as={Link} to="/pricing">Pricing</Nav.Link>
          </Nav>
          <Nav>
            <Nav.Link as={Link} to="/dashboard">Dashboard</Nav.Link>
            <Nav.Link eventKey={2} as={Link} to="/register">
            	<Button variant="outline-light" size='sm'>Get started</Button>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container>
  );
}

export default Header;